import './Home.scss';
import { Name } from './Name.tsx';
import { TopBar } from '../topbar/TopBar.tsx';
import { About } from '../intro/About.tsx';
import { Bottom } from '../footer/Bottom.tsx';
import { DesignCase } from '../gallery/DesignCase.tsx';
import { ApplicationsFolder } from '../gallery/Applications.tsx';
import { CrtEffect } from '../crt/CrtEffect.tsx';

function Home() {
  return (
    <div className="body-all">
      <CrtEffect enabled={false} />
      <TopBar />
      <div className="main-content">
        <Name />
        <About />
        {/* <DesignCase /> */}
        <ApplicationsFolder />
      </div>
      <Bottom />
    </div>
  );
}

export default Home;
